import { ModuleId, modules } from '@factorialco/f0-react'

const isModuleId = (moduleIdentifier: string): moduleIdentifier is ModuleId => {
  const F0modulesIds = Object.keys(modules)
  return F0modulesIds.includes(moduleIdentifier)
}
export const moduleAvailableToModuleId = (
  moduleIdentifier: string | undefined | null
): ModuleId => {
  if (moduleIdentifier && isModuleId(moduleIdentifier)) {
    return moduleIdentifier
  }
  return 'discover'
}
